import { Component, OnInit } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { AuthService } from 'src/app/services/auth.service';
import { ClientsService } from 'src/app/services/clients.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
    standalone: false
})
export class DashboardComponent implements OnInit {

	loading = true;
	num: number = 0;

	statData = [
		{
			title: 'TOTAL PROJECTS',
			value: 0,
			icon: 'ri-folders-line',
			class: 'bg-primary',
			profit: 'down',
			link: 'View all projects',
			route: '/projects',
			circle_color: '#40bb82'
  	}, 
		{
			title: 'Assessments (Monthly)',
			value: 0,
			icon: 'ri-file-list-2-line',
			class: 'bg-secondary',
			persantage: 0,
			profit: 'up',
			month: 'Leads',
			limit: 0,
			link: 'View all examinees',
			route: '/examinees',
			circle_color: '#40bb82'
		}, 
		{
			title: 'TOTAL VIDEO MINUTES (Monthly)',
			value: 0,
			icon: 'ri-movie-line',
			class: 'bg-info',
			persantage: 0,
			profit: 'down',
			month: 'Work',
			limit: 0,
			link: 'View all conversations',
			route: '/conversations',
			circle_color: '#f1963b'
		}
	];

	option = {
    startVal: this.num,
    useEasing: true,
    duration: 2,
    decimalPlaces: 0,
  };

	examinesSeries = [
		{
			name: "Completed",
			value: 0
		},
		{
			name: "In Progress",
			value: 0
		},
		{
			name: "Yet to Start",
			value: 0
		},
		{
			name: "Failed",
			value: 0
		}
	]; 

	conversationsSeries = [
		{
			name: "Completed",
			value: 0
		},
		{
			name: "In Progress",
			value: 0
		},
		{
			name: "Yet to Start",
			value: 0
		},
		{
			name: "Failed",
			value: 0
		}
	]; 

	colorScheme: string | Color = {
    name: 'myScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#45cb85', '#4b38b3', '#ffbe0b', '#f06548']
  };

	currentClient: any = null;
	data: any = null;

	constructor(private clientService: ClientsService, private authService: AuthService) { }

	ngOnInit(): void {
		this.currentClient = this.authService.currentClientValue;

		if (this.currentClient.client_id === 0) {
			this.loading = false;
		} else {
			if (this.currentClient.plan) {
				this.clientService.getClientDashboard().subscribe({
					next: (res) => {
						this.data = res.dashboard_data;
						this.statData[0].value = this.data.projects;
						this.statData[1].value = this.data.assessments.monthly;
						this.statData[1].limit = this.currentClient.plan.configuration.examinees;
						this.statData[1].persantage = this.currentClient.plan.configuration.examinees === 0 ? 0 : Number(((this.data.assessments.monthly/this.currentClient.plan.configuration.examinees)*100).toFixed(0));
						this.statData[2].value = this.data.conversations.monthly;
						this.statData[2].limit = this.currentClient.plan.configuration.video_minutes;
						this.statData[2].persantage = this.currentClient.plan.configuration.video_minutes === 0 ? 0 : Number(((this.data.conversations.monthly/this.currentClient.plan.configuration.video_minutes)*100).toFixed(0));
						this.statData[1].circle_color = this.statData[1].persantage < 50 ? '#40bb82' : this.statData[1].persantage < 75 ? '#f1963b' : '#f06548';
						this.statData[2].circle_color = this.statData[2].persantage < 50 ? '#40bb82' : this.statData[2].persantage < 75 ? '#f1963b' : '#f06548';

						this.examinesSeries[0].value = this.data.assessments.completed;
						this.examinesSeries[1].value = this.data.assessments.in_process;
						this.examinesSeries[2].value = this.data.assessments.yet_to_start;
						this.examinesSeries[3].value = this.data.assessments.failed;

						this.conversationsSeries[0].value = this.data.conversations.completed;
						this.conversationsSeries[1].value = this.data.conversations.in_process;
						this.conversationsSeries[2].value = this.data.conversations.yet_to_start;
						this.conversationsSeries[3].value = this.data.conversations.failed;

						this.loading = false;
					},
					error: (err) => {
						this.loading = false;
					}
				});
			} else {
				this.loading = false;
			}
		}
	}
}
